import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import IdeaCreate from "./IdeaCreate";
import WebinarCreateModal from "../Hub/WebinarCreateModal";


class IdeaList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ideas: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveIdeas();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveIdeas();
        }
    }

    async retrieveIdeas() {
        const url = 'idea_node/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                ideas: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.ideas) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Идеи'}
                    url={'idea'}
                    data={this.state.ideas}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    extraComponents={[
                        {
                            component: IdeaCreate,
                            componentProps: {
                                root: true,
                            }
                        }
                    ]}
                    callBack={this.retrieveIdeas.bind(this)}
                    fields={[
                        {
                            title: 'Полное название',
                            name: 'title',
                            linkPattern: '/idea/map/:linkParam',
                            linkParam: 'id',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(IdeaList)